<h2 style="text-align: center">Nueva Asignatura</h2>
<form [formGroup]="createLessonForm" #lessonCreator>
  <h4 class="form-title">{{ "LESSONS.ID" | translate }}</h4>
  <mat-card class="form-section mat-elevation-z0">
    <mat-card-content fxLayout="column">
      <mat-form-field appearance="outline" class="input-form-field">
        <mat-label>{{ "LESSONS.EDIT_CREATE.NAME" | translate }}</mat-label>
        <input
          #input
          matInput
          formControlName="name"
          placeholder="{{ 'LESSONS.PLACEHOLDER1' | translate }}"
          required
          maxlength="120"
        />

        <mat-hint align="end">{{ input.value?.length || 0 }}/120</mat-hint>
        <mat-hint *ngIf="true">{{ "LESSONS.HINT" | translate }}</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form-field">
        <mat-label>{{ "LESSONS.EDIT_CREATE.COURSE" | translate }}</mat-label>
        <mat-select
          [formControl]="createLessonForm.get('courses')"
          multiple
          disableOptionCentering
          #select
        >
          <mat-select-trigger>
            <mat-chip-list #courseList aria-label="Selección de curso">
              <mat-chip
                *ngFor="let course of createLessonForm.get('courses').value"
                [removable]="true"
                (removed)="removeCourse(course)"
              >
                {{ course.name }}
                <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
              </mat-chip>
              <!-- <input
              placeholder="{{'LESSONS.PLACEHOLDER2'|translate}}"
              #courseInput
              formControlName="courses"
              [matAutocomplete]="courseSelect"
              [matChipInputFor]="courseList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addCourse($event)"> -->
            </mat-chip-list>
          </mat-select-trigger>
          <!-- <mat-autocomplete #courseSelect="matAutocomplete" (optionSelected)="courseSelected($event)"> -->
          <mat-option *ngFor="let course of filteredCourses2" [value]="course">
            {{ course.name }}
          </mat-option>
          <!-- </mat-autocomplete> -->
          <mat-hint *ngIf="true">{{ "LESSONS.HINT2" | translate }}</mat-hint>
        </mat-select>
      </mat-form-field>
      <!-- {{createLessonForm.get('courses').value | json}} -->
      <mat-form-field appearance="outline" class="input-form-field">
        <mat-label>{{ "LESSONS.EDIT_CREATE.CATEGORY" | translate }}</mat-label>
        <mat-select
          [formControl]="this.createLessonForm.get('category')"
          disableOptionCentering
          #select
        >
          <!-- <input matInput formControlName="category" placeholder="{{'LESSONS.PLACEHOLDER3'|translate}}" type="text" [matAutocomplete]="categorySelect"> -->
          <!-- <mat-autocomplete #categorySelect="matAutocomplete" [displayWith]="displayCategory"> -->
          <mat-option
            *ngFor="let category of filteredCategories2"
            [value]="category"
          >
            {{ category.name }}
          </mat-option>
          <!-- </mat-autocomplete> -->
          <mat-hint *ngIf="false">Hint</mat-hint>
        </mat-select>
      </mat-form-field>
      <!-- <mat-form-field appearance="outline" class="input-form-field">
          <mat-label>Edad-Nivel</mat-label>
          <input matInput formControlName="age" placeholder="Edad-Nivel">
          <mat-hint *ngIf="false">Hint</mat-hint>
        </mat-form-field> -->
    </mat-card-content>
  </mat-card>
  <h4 class="form-title">
    {{ "LESSONS.EDIT_CREATE.DESCRIPTION" | translate }}
  </h4>
  <mat-card class="form-section mat-elevation-z0">
    <mat-card-content fxLayout="column">
      <mat-form-field appearance="outline" class="input-form-field">
        <mat-label>{{
          "LESSONS.EDIT_CREATE.DESCRIPTION_MSG" | translate
        }}</mat-label>
        <textarea
          #input
          matInput
          formControlName="resources"
          placeholder="{{ 'LESSONS.PLACEHOLDER4' | translate }}"
          maxlength="400"
        ></textarea>
        <mat-hint align="end">{{ input.value?.length || 0 }}/400</mat-hint>
        <mat-hint *ngIf="false"
          >Tienes solo 400 caracteres para la descripción</mat-hint
        >
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <!-- <div fxLayoutGap="row" [style.margin-top.rem]="1">
      <div fxFlex></div>
      <div fxFlexAlign="end">
        <button mat-flat-button color="primary" (click)="createLesson()">
          {{ "LESSONS.EDIT_CREATE.SAVE_BTN" | translate }}
        </button>
      </div>
    </div> -->
</form>
<div mat-dialog-actions align="end">
  <button
    mat-flat-button
    color="primary"
    cdkFocusInitial
    (click)="createLesson2()"
  >
    {{ "MENU_CARD.ACCEPT" | translate }}
  </button>
  <button
    mat-flat-button
    *ngIf="data.messageType === 'question' || data.messageType === 'warning'"
    color="accent"
    [mat-dialog-close]="false"
    (click)="closeMe()"
  >
    {{ "MENU_CARD.CANCEL" | translate }}
  </button>
  <button
    mat-flat-button
    *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'"
    color="primary"
    [mat-dialog-close]="true"
    (click)="closeMe()"
  >
    {{ "MENU_CARD.CANCEL" | translate }}
  </button>
</div>
